import * as React from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import "../RepEditPage.css";
import Category from "../../components/RepEditCategories/Category.js";
import NavbarLogin from "../../components/navbarDashboard/NavbarDashboard.js";
import { Button } from "@mui/material";
import { Card, CardContent } from "@mui/material";
import { Await, useFetcher } from "react-router-dom";
import {
    STAFF_GRANT_IN_AID,
    STAFF_SELF_SUPPORTING,
    AICTE_APPROVAL,
    AU_AFFILIATION,
    REPORT,
    AdministratorReportContentContext,
    AdministratorReportContentContextProvider,
} from "../../providers/administratorReportContentProvider.js";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import AdministratorJoditEditor from "../../components/QuillEditors/AdministratorJoditEditor.js";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
  height: "100%",
}));

export default function AdministratorEdit() {
  const navigation = useNavigate();
  const { id } = useParams();
  const { title } = useParams();
  const { currentYear } = useParams();
  const { currentQuarter } = useParams();
  const handleUpdate = () => {
    const requestOptions = {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("jwt")} `,
      },
      body: JSON.stringify({ data: { content } }),
    };
    fetch(
      `${process.env.REACT_APP_BASE_URL}/api/report/${id}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        if(localStorage.getItem("role")==="REPRESENTATIVE" && localStorage.getItem("departmentId")==="ADMINISTRATOR"){
          navigation(`/administratorEdit/${id}/${currentYear}/${currentQuarter}`);
        }
      });
  };
  const { setContent, content } = React.useContext(AdministratorReportContentContext);
  const [clickedItem, setClickedItem] = React.useState("");

  const sections = [
    { name: "Staff (Grant in aid)", key: STAFF_GRANT_IN_AID },
    { name: "Staff (Self supporting)", key: STAFF_SELF_SUPPORTING },
    { name: "AICTE Approval", key: AICTE_APPROVAL },
    { name: "AU Affiliation", key: AU_AFFILIATION },
    { name: "Report", key: REPORT },
  ];
  
  React.useEffect(() => {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("jwt")}`,
      },
    };

    fetch(
      `${process.env.REACT_APP_BASE_URL}/api/report/${currentYear}/${currentQuarter}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((data) => {
        setContent((prevContent) => ({ ...prevContent, ...data.content }));
        setClickedItem(sections.find((section) => section.name === title).key);
      });
  }, []);

  const handleEditorContentChange = (newContent) => {
    setContent((prevContent) => ({
      ...prevContent,
      [clickedItem]: newContent,
    }));
  };

  return (
    <>
      <NavbarLogin />
      <Box sx={{ flexGrow: 1, marginTop: "100px", marginBottom: "5%" }}>
        <Grid container spacing={2}>
          <Grid item xs={3} columnSpacing={{ xs: 1, sm: 3, md: 3 }}>
            <Item>
              {sections.map((section) => (
                <React.Fragment key={section.key}>
                  <Category
                    key={section.key}
                    category={section.name}
                    currentlySelected={
                      section.key === clickedItem ? true : false
                    }
                    handleClick={() => setClickedItem(section.key)}
                  />
                </React.Fragment>
              ))}
            </Item>
          </Grid>
          {/* <Button
            variant="contained"
            style={{
              position: "fixed",
              bottom: 16,
              right: 500,
              color: "#ffffff",
              backgroundColor: "#035088",
            }}
          >
            Submit
          </Button> */}
          <Grid item xs={9}>
            <Item>
              <AdministratorJoditEditor subTitle={clickedItem} editorContent={content[clickedItem] ? content[clickedItem] : ''} onContentChange={handleEditorContentChange} />
            </Item>
          </Grid>
          <Card
            style={{
              position: "fixed",
              bottom: 0,
              right: 0,
              backgroundColor: "#E2EBFC", // Set your desired card background color
              width: "100%",
              height: "8%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              //opacity: "80%",
            }}
          >
            <CardContent>
              <Button
                variant="contained"
                style={{
                  backgroundColor: "#035088",
                  marginTop: "8px",
                  zIndex: 1,
                }}
                onClick={handleUpdate}
              >
                Update
              </Button>
            </CardContent>
          </Card>
        </Grid>
      </Box>
    </>
  );
}
